import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import Cookies  from "js-cookie";
import Swal from 'sweetalert2';

// Insert editorial Media
const API_BASE_URL = process.env.REACT_APP_BASE_URL


export const insertEditorialMedia = createAsyncThunk(
  'editorial/insert',
  async (data, { rejectWithValue }) => {
    const formdata = new FormData();
    if (Array.isArray(data?.images)) {
      data.images.forEach((image, index) => {
        formdata.append(`images[${index}]`, image); // Send as an indexed array
      });
    } else {
      formdata.append("images", data?.images); // For single file
    }
    try {
      const response = await axios.post(`${API_BASE_URL}/editorial/insert`, formdata, {
        headers: {
          'Content-Type': 'multipart/form-data', 
          Authorization: `Bearer ${Cookies.get('token')}` ,
        },
      });

      // Show success alert
      Swal.fire({
        icon: 'success',
        title: 'Success!',
        text: 'Media uploaded successfully.',
      });

      return response.data;
    } catch (error) {
      // Show error alert if something goes wrong
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: error.response?.data?.message || 'Something went wrong!',
      });

      return rejectWithValue(error.response?.data);
    }
  }
);

// Edit editorial Media
export const editEditorialMedia = createAsyncThunk(
  'editorial/edit',
  async (data, { rejectWithValue }) => {
    const formdata = new FormData();
    if (Array.isArray(data?.images)) {
      data.images.forEach((image, index) => {
        formdata.append(`images[${index}]`, image); // Send as an indexed array
      });
    } else {
      formdata.append("images", data?.images); // For single file
    }
    try {
      const response = await axios.put(`${API_BASE_URL}/editorial/edit/${data?.id}`, formdata, {
        headers: {
          'Content-Type': 'multipart/form-data', // Set content-type for file upload
          Authorization: `Bearer ${Cookies.get('token')}` 
        },
      });

      // Show success alert
      Swal.fire({
        icon: 'success',
        title: 'Success!',
        text: 'editorial media updated successfully.',
      });

      return response.data;
    } catch (error) {
      // Show error alert if something goes wrong
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: error.response?.data?.message || 'Something went wrong!',
      });

      return rejectWithValue(error.response?.data);
    }
  }
);

// Delete editorial Media
export const deleteEditorialMedia = createAsyncThunk(
  'editorial/delete',
  async (id, { rejectWithValue }) => {
    try {
      const response = await axios.delete(`${API_BASE_URL}/editorial/delete/${id}`,{
        headers:{ Authorization: `Bearer ${Cookies.get('token')}` }
      });
      
      // Show success alert
      Swal.fire({
        icon: 'success',
        title: 'Deleted!',
        text: 'editorial media has been deleted successfully.',
      });

      return response.data;
    } catch (error) {
      //console.log(error,"editorial")
      // Show error alert if something goes wrong
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: error.response?.data?.message || 'Failed to delete editorial media.',
      });

      return rejectWithValue(error.response?.data);
    }
  }
);

// Fetch all editorial Media
export const fetchAllEditorialMedia = createAsyncThunk(
  'editorial/fetchAll',
  async (data, { rejectWithValue }) => {
    
    try {
      let {page, limit} = data;
      const response = await axios.get(`${API_BASE_URL}/editorial/fetch`,{
        params: {
          page,
          limit
        }
      });
      //console.log(response,"responseresponse")
      return response.data;
    } catch (error) {
      //console.log(error)
      return rejectWithValue(error.response.data);
    }
  }
);

export const fetchAllEditorialSliders = createAsyncThunk(
  "editorialSlider/fetchAllEditorialSliders",
  async ( data, { rejectWithValue }) => {
    let {page, limit } = data 
    try {
      const response = await axios.get(`${API_BASE_URL}/editorial-slider/fetch`, {
        params: { page, limit },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);
